import { fetchApi } from '@/config/axiosSetting.ts';
import {
  ParticipantsIncidentQueryParamsType,
  ParticipantsIncidentQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/ParticipantsIncidentQuery.type';

export const ParticipantsIncidentQueryFunction = ({
  id,
  user,
  view_type,
}: ParticipantsIncidentQueryParamsType): Promise<ParticipantsIncidentQueryResponseType> =>
  fetchApi({
    url: `/property/reports/${id}/accident_users/damaged/list/`,
    params: { user_type: user, view_type },
  });
